import * as actionTypes from '../actionTypes';
import { updateObject } from './utility';

const initialState = {
  loading: false,
  permissionLoading: true,
  user: '',
  permission: {},
  error: null,
  type: null,
};

const updateProfileFail = (action, state) => {
  return updateObject(state, {
    error: 'error',
  });
};
const updateStart = (action, state) => {
  return updateObject(state, {
    loading: true,
  });
};

const setUpdateprofile = (action, state) => {
  return updateObject(state, {
    user: action.payload,
    loading: false,
  });
};

const setPermissions = (action, state) => {
  return updateObject(state, {
    permission: action.payload,
    // permissionLoading: false,
  });
};

const updatePermissionLoading = (action, state) => {
  return updateObject(state, {
    permissionLoading: action.payload,
  });
};

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_PROFILE:
      return updateStart(action, state);

    case actionTypes.SET_PROFILE:
      console.log(action);
      localStorage.setItem('user', JSON.stringify(action.payload));
      return setUpdateprofile(action, state);

    case actionTypes.GET_PROFILE_FAIL:
      return updateProfileFail(action, state);

    case actionTypes.GET_PERMISSIONS:
      return updatePermissionLoading(action, state);

    case actionTypes.SET_PERMISSIONS:
      return setPermissions(action, state);

    default:
      return state;
  }
};

export default profileReducer;
